<template>
  <v-container class="my-0 ml-0 mr-n2 pa-0" fluid>
    <!-- <v-row density="compact" class="ma-0 pa-0">
      <v-col cols="12" class="ma-0 pa-2" density="compact">
        <p>Prompt Studio. Work on your prompts, then assign them when you're ready.</p>
      </v-col>
    </v-row> -->
    <v-row density="compact" class="ma-0 pa-0">
      <v-col v-if="promptListSorted != null && promptListSorted.length > 0" cols="2" class="ma-0 pa-2"
        density="compact">
        <div class="d-flex align-center justify-space-between ml-1">
          <Button icon="mdi-plus" v-if="localPromptList != null && localPromptList.length > 0" :click="addPrompt"
            size="x-large" tooltip="New Chat" variant="outlined" density="default" color="secondary"></Button>
          <v-tooltip text="The prompt studio is currently in beta and may have bugs." location="top">
            <template v-slot:activator="{ props }">
              <v-chip v-bind="props" size="small" color="secondary" class="mx-auto">
                BETA
              </v-chip>
            </template>
          </v-tooltip>
        </div>
        <v-tabs v-model="selectedPrompt" @update:modelValue="onTabChange" direction="vertical" color="primary" bg-color="background" class="tabs mt-2">
          <v-tab v-for="(p, index) in promptListSorted" :key="`${index}_${p.id}`" :value="p.id">
            <p class="text-subtitle-2 tab-title">{{ p.name }}</p>
            <v-btn class="optionsBtn" variant="text" icon :rounded="0">
              <v-icon>mdi-dots-vertical</v-icon>
              <v-menu activator="parent" density="compact">
                <v-list density="compact">
                  <v-list-item density="compact" class="mt-1 mb-0 mx-2 pa-0">
                    <v-btn variant="text" size="small" color="warning" icon="mdi-trash-can-outline" @click="deletePrompt(p.id)" />
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-btn>
          </v-tab>
        </v-tabs>
      </v-col>
      <v-col v-if="promptListSorted != null && promptListSorted.length > 0" cols="10" class="ma-0 pa-2"
        density="compact">
        <v-window v-model="selectedPrompt">
          <v-window-item v-for="(p, index) in promptListSorted" :key="`${index}_${p.id}`" :value="p.id"
            class="prompt-scroll overflow-y-auto">
            <Prompt :id="p.id" />
          </v-window-item>
        </v-window>
      </v-col>
      <v-col v-if="localPromptList != null && localPromptList.length === 0" cols="4" xl="3" class="ma-0 pa-2"
        density="compact">
        <v-card @click="addPrompt" class="ma-0 pa-2 card add-card" color="surface" density="compact" variant="elevated"
          elevation="12">
          <p>New prompt</p>
          <v-icon class="add-icon" icon="mdi-plus"></v-icon>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script lang="ts">
import Button from '@/components/sub/Button.vue'
import Prompt from '@/components/Prompt.vue'
import { PromptConfig } from '@/store/prompts'
import { sleep } from '@/utils/general'
import { nanoid } from 'nanoid'
import { Options, mixins } from 'vue-class-component'
import { mapGetters } from 'vuex'
import AnalyticsMixin from '@/mixins/AnalyticsMixin'


@Options({
  components: {
    Button,
    Prompt
  },
  computed: {
    ...mapGetters(['promptList'])
  }
})
export default class PromptStudio extends mixins(AnalyticsMixin) {
  promptList!: PromptConfig[]
  // localPromptList: PromptConfig[] = []
  selectedPrompt: string = ''
  
  mounted() {
    this.trackComponentView('prompt_studio');
    // Initialize localPromptList with data from the store
    // this.localPromptList = [...this.promptList]
  }

  get localPromptList(): PromptConfig[] {
    return this.promptList ?? []
  }

  // Watch for changes in promptList from the store
  updated() {
    // Update localPromptList when promptList changes
    // if (JSON.stringify(this.promptList) !== JSON.stringify(this.localPromptList)) {
    //   this.localPromptList = [...this.promptList]
    // }
  }
  
  get promptListSorted(): PromptConfig[] {
    if (this.localPromptList == null) {
      return []
    }
    return Array.from(this.localPromptList).sort(
      (a, b) =>
        (b.target != null ? b.target.timestamp : b.timestamp) - (a.target != null ? a.target.timestamp : a.timestamp)
    )
  }

  async addPrompt() {
    this.trackButtonClick('create_prompt_session', 'click');
    const newPrompt: PromptConfig = {
      id: nanoid(),
      timestamp: Date.now(),
      name: 'New Prompt',
      promptList: [],
      context: [],
      temperature: 0.1,
      maxTokens: -1,
      history: []
    }
    
    // Save the new prompt to the store
    this.$store.dispatch('setPromptConfig', newPrompt)
    
    // No need to manually push to localPromptList as it's a computed property
    // that will automatically update when the store changes
    
    await sleep(250)
    this.selectedPrompt = newPrompt.id
  }

  deletePrompt(id: string) {
    this.trackButtonClick('delete_prompt_session', 'click', { prompt_id: id });
    this.$store.dispatch('deletePrompt', id)
  }
  
  onTabChange(promptId: unknown) {
    if (typeof promptId === 'string') {
      this.trackButtonClick('select_prompt_session', 'click', { prompt_id: promptId });
      this.selectedPrompt = promptId;
    } else {
      this.trackButtonClick('select_prompt_session', 'click', { prompt_id: 'unknown' });
    }
  }
}
</script>
<style scoped lang="scss">
// .no-ghost {
//   ::v-deep(.v-window__container) {
//     overflow: hidden;
//   }
// }
.prompt-scroll {
  height: calc(100vh - 152px);
}
.add-card {
  border: 1px solid rgba(255, 255, 255, 0.3);
  height: 350px;
  text-align: center;
  cursor: pointer;

  p {
    margin-top: 130px;
  }
}
.add-card-small {
  border: 1px solid rgba(255, 255, 255, 0.3);
  text-align: center;
  cursor: pointer;
}
.tab-title {
  max-width: 185px;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
.optionsBtn {
  position: absolute;
  right: 0;
}
</style>
